// import { initialData, ticketStatus } from "./constants";

// export function ticketsDataDTO(tickets) {
//   if (!tickets || !Array.isArray(tickets)) {
//     return initialData;
//   }
//   console.log({ tickets });

//   const ticketsDataObj = tickets.reduce((obj, state) => {
//     const assigned = obj?.["assigned"] || [];
//     const inProgressTicketIds = obj?.["pending"] || [];
//     const waitingForReviewIds = obj?.["waitingForReview"] || [];
//     const completedIds = obj?.["closed"] || [];

//     function getPreviousIds() {
//       if (state.status === "assigned") {
//         return assigned;
//       }
//       if (state.status === "pending") {
//         return inProgressTicketIds;
//       }

//       if (state.status === "waitingForReview") {
//         return waitingForReviewIds;
//       }
//       if (state.status === "closed") {
//         return completedIds;
//       }
//       return "";
//     }

//     obj = {
//       ...obj,
//       tickets: {
//         ...obj?.tickets,
//         [state["caseId"]]: state,
//       },
//       [ticketStatus[state?.status]]: [...getPreviousIds(), state?.caseId],
//     };

//     return obj;
//   }, {});

//   return {
//     ...initialData,
//     tickets: ticketsDataObj?.tickets,
//     columns: {
//       ...initialData?.columns,
//       assigned: {
//         ...initialData?.columns?.assigned,
//         ticketIds: ticketsDataObj?.assigned,
//       },
//       pending: {
//         ...initialData?.columns?.["pending"],
//         ticketIds: ticketsDataObj?.["pending"],
//       },
//       waitingForReview: {
//         ...initialData?.columns?.waitingForReview,
//         ticketIds: ticketsDataObj?.waitingForReview,
//       },
//       closed: {
//         ...initialData?.columns?.closed,
//         ticketIds: ticketsDataObj?.closed,
//       },
//     },
//   };
// }

const STATUS_META = {
  pending: { title: "In Progress", color: "#F4BD00" },
  assigned: { title: "Assigned Tickets", color: "#8996A9" },
  waitingForReview: { title: "Waiting For Review", color: "#FF8800" },
  closed: { title: "Completed", color: "#22C55E" },
};

export function createInitialData(statuses = []) {
  const storedColumnOrder = JSON.parse(
    localStorage.getItem("statusColumnsOrder"),
  );

  const columns = {};
  const columnOrder = [];

  statuses.forEach((status, index) => {
    columns[status.settingName] = {
      id: status.settingName,
      title: status.settingName,
      settingId: status.settingId,
      ticketIds: [],
      color: "#CBD5E1",
    };
    columnOrder.push(status.settingName);
  });

  return {
    tickets: {},
    columns,
    columnOrder: storedColumnOrder || columnOrder,
    // columnOrder: columnOrder,
  };
}

export function ticketsDataDTO(tickets = [], statusesData = []) {
  const statuses = statusesData?.map((item) => item.settingName);

  const initialData = createInitialData(statusesData);

  if (!Array.isArray(tickets)) {
    return initialData;
  }

  return tickets.reduce((acc, ticket) => {
    const { caseId, status } = ticket;

    // Store ticket
    acc.tickets[caseId] = ticket;

    // Ensure column exists (safe guard)
    if (!acc.columns[status]) {
      acc.columns[status] = {
        id: status,
        title: status,
        ticketIds: [],
        color: "#CBD5E1",
      };
      // acc.columnOrder.push(status);
    }

    // Push ticket id into correct column
    acc.columns[status].ticketIds.push(caseId);

    return acc;
  }, initialData);
}
